















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DetalhesSidebar from "@/components/detalhes/DetalhesSidebar.vue";
import BackgroundImage from "@/components/BackgroundImage.vue";
import ResumoToggle from '@/components/ResumoToggle.vue';

@Component({
    components: {
        ResumoToggle,
        BackgroundImage,
        DetalhesSidebar,
        'pab-header': Header,
        'pab-footer': Footer
    }
})
export default class App extends Vue {
    public mounted () {
        document.title = 'Protruck - Cotação Online';
        this.$store.commit('SET_HISTORY_ENABLED', true);
        // Muda titulo da página quando muda de rota
        this.$router.beforeEach(( to, from, next ) => {
            document.title = to.meta.title;
            next();
        });
        // Rola pro topo quando muda de rota
        this.$router.afterEach(( to, next ) => {
            window.scrollTo(0, 0);
        });
    }
}
